import { FC } from 'react';
import Tab, { TabProps } from '@material-ui/core/Tab';

export interface IPaymentTabProps extends TabProps {
  icon?: string;
}

const PaymentMethodTab: FC<IPaymentTabProps> = ({ label, icon, ...rest }) => (
  <Tab
    {...rest}
    label={
      <>
        {icon && <img src={icon} />}
        <strong>{label}</strong>
      </>
    }
  />
);

export default PaymentMethodTab;
